import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { TripForm } from '../components/TripForm';
import { useTrip } from '../hooks/useTrip';
import type { UpdateTripData } from '../types';

export function EditTripPage() {
  const { tripId } = useParams<{ tripId: string }>();
  const navigate = useNavigate();
  const { trip, isLoading, error, updateTrip } = useTrip(tripId);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: UpdateTripData) => {
    setIsSubmitting(true);
    try {
      await updateTrip(data);
      navigate(`/trips/${tripId}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !trip) {
    return (
      <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
        <Alert severity="error">{error || 'Trip não encontrada'}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Editar Trip
      </Typography>
      <Paper sx={{ p: 3 }}>
        <TripForm
          initialValues={{
            title: trip.title,
            description: trip.description || undefined,
            startDate: trip.startDate,
            endDate: trip.endDate,
            category: trip.category,
            privacy: trip.privacy,
          }}
          onSubmit={handleSubmit}
          onCancel={() => navigate(`/trips/${tripId}`)}
          isEditing
          isSubmitting={isSubmitting}
        />
      </Paper>
    </Box>
  );
}
